
import './ParallelSets.css'
import * as React from "react";
import { assert_key_hier } from '../../../helper';
const d3 = require("d3");
const d3_parsets = require("./d3.parsets.js");
export interface IProps {
    PSJson:any,
    PSDimensions:any,
    ReversedDimMapping:any,
    changeFilters:any,
    width: number,
    height:number,
}
export interface IState {
}

export default class ParallelCoordinates extends React.Component<IProps, IState>{

    constructor(props:IProps) {
        super(props);
        this.onRibbonClick = this.onRibbonClick.bind(this);
        this.clearFilter = this.clearFilter.bind(this);
        this.onCategoryClick = this.onCategoryClick.bind(this);
        this.state = {

        }
        //this.resize.bind(this);
        // Flow:
        // 1. Constructor
        // 2. componentWillMount()
        // 3. render()
        // 4. componentDidMount()
        // If props update:
        // 4.1 componentWillReceiveProps(nextProps : IProps), then goto 5.
        // If States update
        // 5. shouldComponentUpdate() if return false, then no rerendering.
        // 6. if True, then componentWillUpdate
        // 7. render()
        // 8. componentDidUpdate
        // If Unmount, then componentWillUnmount()
    }
    // Component Configurable Methods.
    componentDidMount(){
        this.renderD3();
    }
    // Mount
    componentWillMount() {
        //console.log('Component will mount!')
     }

     
    // Update
     shouldComponentUpdate(nextProps:IProps, nextState:IState){
        return true;
    }
     componentWillUpdate(nextProps:IProps, nextState:IState) {
        //console.log('Component will update!');
     }

     componentDidUpdate(prevProps:IProps, prevState:IState) {
        //console.log('Component did update!')
        if(prevProps.PSJson.name !== this.props.PSJson.name || 
            !this.comparePSDimensions(prevProps.PSDimensions, this.props.PSDimensions) ||
            prevProps.width !== this.props.width ||
            prevProps.height !== this.props.height ){
            d3.selectAll("#ParallelSets_SVG").remove();
            this.props.changeFilters({});
            this.renderD3();
        }

        
     }
     public comparePSDimensions(prev:any, current:any){
         if(prev.length !== current.length){
             return 0; // Not equal
         }else{
             let flag = 1;
            for(let i = 0; i<prev.length; i++){
                if(prev[i] !== current[i]){
                    flag = 0;
                    break;
                }
            }   
            return flag;
         }
     }
     public onRibbonClick(e:any, ReversedDimMapping:any){
        const filters:any = {};
        let current = e.data;
        while(current){
            if(current.hasOwnProperty("parent")){
                filters[ReversedDimMapping[current.dimension]] = [current.name];
                current = current.parent;
            }else{
                break;
            }
        }
        //filters[feature] = selected;            
        this.props.changeFilters(filters);
    }
    public onCategoryClick(e:any, ReversedDimMapping:any){
        console.log("onCategoryClick", e);
        const filters:any = {};
        let current = e.data;
        filters[ReversedDimMapping[current.dimension.name]] = [current.name];
        this.props.changeFilters(filters);
    }
    public clearFilter(){
        console.log("clearFilter");
        this.props.changeFilters({});
    }
    public renderD3(){
        // PSJson {"PSData":[{specific dimension}], "name"}
        
        let {width, height, PSJson, PSDimensions, ReversedDimMapping} = this.props;
        
        // Parallel Sets
        
        let PSData = PSJson.PSData;
        let chart_dimensions = PSDimensions;

        //let chart_dimensions = ["Survived", "Sex", "Age", "Class"];
        if(chart_dimensions.length <= 1){
            console.log("The number of dimensions must be larger or equal to 2.")
            return ;
        }
        // tension = 1 --> line
        // tension = 0.5 --> curve
        var chart = d3.parsets()
            .dimensions(chart_dimensions)
            .width(width)
            .height(height)
            .tension(1)
            .on("ribbonClick",(e:any)=>{this.onRibbonClick(e,ReversedDimMapping)})
            .on("sortDimensions",this.clearFilter)
            .on("sortCategories",this.clearFilter)
            .on("categoryClick", (e:any)=>{this.onCategoryClick(e,ReversedDimMapping)})
            
        var vis = d3.select("#parallelSets").append("svg")
            .attr("id","ParallelSets_SVG")
            .attr("width", chart.width())
            .attr("height", chart.height());

        let csv = PSData;
        vis.datum(csv).call(chart);

    }
    public render() {
        return (
            <div id="parallelSets" />
        )

    }
}

